/** Synthetic driver id for jobs with no assigned driver (API driver_id 0 / missing). */
export const UNASSIGNED_ROUTE_DRIVER_ID = 0;

/** True when a driver route is selected (includes unassigned id 0). */
export const isRouteDriverSelected = driverId =>
  driverId != null && Number.isFinite(Number(driverId));

/**
 * Backend may return driver_id as number or string. Treat 0, null, empty, and invalid as unassigned.
 */
export const parseDriverIdValue = value => {
  if (value == null || value === undefined || value === '') {
    return null;
  }
  const id = parseInt(value, 10);
  return Number.isFinite(id) ? id : null;
};

export const resolveAssignedDriverId = row => {
  if (!row || row.isRouteView) {
    return null;
  }

  const status = parseInt(row.status ?? row.job_status, 10);
  if (status === 9 || status === 10) {
    const canceledId = parseInt(row.canceled_driver_id, 10);
    return Number.isFinite(canceledId) && canceledId > 0 ? canceledId : null;
  }

  const id = parseDriverIdValue(row.driver_id);
  return id != null && id > 0 ? id : null;
};

/** Group key for route view table headers: one block for all unassigned jobs. */
export const getRouteViewGroupDriverId = rowOrDriverId => {
  if (rowOrDriverId != null && typeof rowOrDriverId === 'object') {
    const assigned = resolveAssignedDriverId(rowOrDriverId);
    return assigned != null ? assigned : UNASSIGNED_ROUTE_DRIVER_ID;
  }
  const id = parseDriverIdValue(rowOrDriverId);
  if (id == null || id <= 0) {
    return UNASSIGNED_ROUTE_DRIVER_ID;
  }
  return id;
};

export const isUnassignedRouteViewLabel = label => {
  const text = `${label || ''}`.trim();
  return !text || /^unassigned$/i.test(text);
};

export const isAssignedRouteViewDriver = (driverId, driverList) => {
  const id = parseDriverIdValue(driverId);
  if (id == null || id <= 0) {
    return false;
  }
  if (!driverList?.length) {
    return true;
  }
  const match = driverList.find(item => String(item.id) === String(id));
  if (!match) {
    return false;
  }
  return !isUnassignedRouteViewLabel(match.label);
};

/** Driver Routes sidebar: assigned drivers only (unassigned stays in the jobs table). */
export const shouldShowRouteViewDriverSummary = (summary, driverList) => {
  const id = parseDriverIdValue(summary?.driver_id);
  if (id == null || id <= 0) {
    return false;
  }
  return isAssignedRouteViewDriver(summary?.driver_id, driverList);
};

export const getRouteViewDriverSummaryLabel = (summary, driverList) => {
  if (!summary) {
    return 'Unassigned';
  }
  const id = parseDriverIdValue(summary.driver_id);
  if (id === UNASSIGNED_ROUTE_DRIVER_ID) {
    return 'Unassigned';
  }
  const label = summary.driver_label?.trim();
  if (label) {
    return label;
  }
  const match = driverList?.find(item => String(item.id) === String(id));
  return match?.label || 'Unassigned';
};
